import { React, useEffect, useState, useRef } from "react";
import styles from "./career.module.scss";
import baseImg from "../../assests/careersBgImg.png";

const Career = () => {
  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
        console.log(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) {
      observer.observe(MyRef.current);
    }

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div
          ref={MyRef}
          className={visible ? styles.baseImgEvent : styles.baseImg}
        >
          <img src={baseImg} alt="" />
        </div>
        <div className={styles.top} ref={MyRef}>
          <div className={visible ? styles.headingEvent : styles.heading}>
          We're always looking for Great Talent!
          </div>
          <div
            className={visible ? styles.descriptionEvent : styles.description}
          >
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur
            rem facere odit exercitationem ducimus voluptates eum qui quis saepe
            deleniti! Lorem ipsum dolor sit amet consectetur adipisicing elit.
            Ducimus, pariatur!
          </div>
          <div>
            <div
              className={visible ? styles.bottom : styles.bottomEvent}
              ref={MyRef}
            >
              <div className={styles.content}>
                Currently we don't have any open positions, but we're always
                interested in connecting with talented individuals. Feel free to
                send us your resume for future opportunities.
              </div>
              <button
                type="button"
                className={styles.button}
                onClick={() =>
                  (window.location.href =
                    "mailto: careers@krihaitsolutions.com")
                }
              >
                careers@krihaitsolutions.com
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Career;
